import { useEffect, useState } from "react";
import Footer from "../../../components/Footer/Footer";
import InnerNav from "../../../components/InnerNav/InnerNav";
import Zodiac from "../../../components/ZodiacSign/Zodiac";
import "./Property.scss";
import MuhuratLink from "../../../components/MuhuratLink/MuhuratLink";
import axios from "axios";
import city from '../../../city.json'

const Property = () => {
  const [expandedMonths, setExpandedMonths] = useState({});
  const [propertyData, setPropertyData] = useState({});

  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);
  const [location, setLocation] = useState("Kolkata");

  const [showPopup, setShowPopup] = useState(false);

  // temporary values (for input fields)
  const [tempYear, setTempYear] = useState(currentYear);
  const [tempLocation, setTempLocation] = useState("Kolkata");
  const [suggestions, setSuggestions] = useState([]);


  const handleToggle = (index) => {
    setExpandedMonths((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  useEffect(() => {
    const fetchPropertyData = async () => {
      try {
        const res = await axios.get(
          `https://core-c343.onrender.com/api/property-Purchase?year=${year}&location=${encodeURIComponent(location)}`
        );
        const data = await res.data;
        setPropertyData(data?.propertyPurchaseMuhurat || {});
      } catch (err) {
        console.error("Failed to fetch Property Muhurat data:", err);
      }
    };

    fetchPropertyData();
  }, [year, location]);

  const formatDate = (dateStr) => {
    const [yyyy, mm, dd] = dateStr.split("-");
    return `${dd}/${mm}/${yyyy}`;
  };

  const monthKeys = Object.keys(propertyData);

  const handleSubmit = () => {
  setYear(tempYear);
  setLocation(tempLocation);
};

  const handleChange = (e) => {
    const value = e.target.value;
    setTempLocation(value);

    // filter cities when user types
    if (value.length > 0) {
      const filtered = city.filter((c) =>
        c.city.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 4)); // show only first 4 results
    } else {
      setSuggestions([]);
    }
  };

  const handleSelect = (cityName) => {
    setTempLocation(cityName);
    setSuggestions([]);
  };

  return (
    <div className="Property-container">
      <InnerNav />
      <div className="Property-content">
        <Zodiac />

        <div className="location-date">
        <div className="year-selector">
        <label htmlFor="year">Select Year: </label>
        <input
          id="year"
          type="number"
          min="1900"
          max="2100"
          value={tempYear}
          onChange={(e) => setTempYear(Number(e.target.value))}
        />
        <button className="submit" onClick={handleSubmit}>Submit</button>
      </div>

       <div className="input-with-icon">
                  <span className="icon">📍</span>
                  <input
                    type="text"
                    value={tempLocation}
                    onChange={handleChange}
                    placeholder="Enter location"
                  />
                  {suggestions.length > 0 && (
                    <ul className="dropdown">
                      {suggestions.map((c, idx) => (
                        <li key={idx} onClick={() => handleSelect(c.city)}>
                          {c.city}, {c.state}, {c.country}
                        </li>
                      ))}
                    </ul>
                  )}
                  </div>
          </div>
          <div className="meaning">
          <p className="meaning1">⚠️: Not Recommended / Ashubh Muhurat</p>
        <p className="meaning1">✅: Shubh Muhurat</p>
      </div>
        <h1 className="Property-title">Property Purchase Muhurat</h1>

        {monthKeys.length > 0 ? (
          monthKeys.map((month, index) => {
            const isExpanded = expandedMonths[index];
            const events = propertyData[month] || [];
            const visibleProperty = isExpanded ? events : events.slice(0, 6);

            return (
              <div className="monthVivah" key={index}>
                <h2 className="Property-heading">{month}, {year}</h2>
                <div className="list-of-Property">
                  {visibleProperty.map((item, i) => (
                    <div className="Property-card" key={i}>
                      <div className="Property-info">
                        <p className="tag">{item.tag ? item.tag.slice(0, 2) : ""}</p>
                        <p><strong>Date:</strong> {formatDate(item.date)}</p>
                        {item.weekday && <p><strong>Weekday:</strong> {item.weekday}</p>}
                        {item.tithi && <p><strong>Tithi:</strong> {item.tithi}</p>}
                        {item.nakshatra && <p><strong>Nakshatra:</strong> {item.nakshatra}</p>}
                        {item.verdict && <p><strong>Verdict:</strong> {item.verdict}</p>}
                        {item.rating && <p><strong>Rating:</strong> {item.rating}</p>}
                        {item.score !== undefined && <p><strong>Score:</strong> {item.score}</p>}
                      </div>
                    </div>
                  ))}
                </div>

                {events.length > 6 && (
                  <button className="toggle-btn" onClick={() => handleToggle(index)}>
                    {isExpanded ? "Show less" : "Show more"}
                  </button>
                )}
              </div>
            );
          })
        ) : (
          <p>No Property Purchase Muhurat data available for {year}.</p>
        )}
       
        <section className="vivah-wrapper">
          <h1 className="vivah-title">About Property Purchase</h1>
          <div className="vivah-texts">
            <p>
We have listed auspicious dates to purchase any property including house, flat, plot, and land. In the modern context, these dates are considered good for property registration, as one becomes the legal owner of the property only after registration, irrespective of when the advance payment was made to the builder or owner.

Thursdays and Fridays are regarded as the most auspicious weekdays to purchase property. In case of urgency, weekdays can be ignored, but it is still recommended to ensure that at least an auspicious Nakshatra along with an auspicious weekday prevails at the time of registration.

Auspicious dates to purchase and register any property are calculated after performing Panchang Shuddhi or Panchangam Shuddhi. Panchang Shuddhi not only provides auspicious dates but also Shubh timings to buy property.

Only those Muhurats which prevail for at least 5 minutes are considered, while those lasting for less than 5 minutes are discarded. Muhurats are calculated from Sunrise to Sunrise. If a 
              <span 
              className="link-text" 
              onClick={() => setShowPopup(true)}
              style={{textDecoration: 'underline', color: 'red', fontStyle: 'italic', marginLeft: '10px'}}
              >24+ time format
              </span>
 is selected, then Muhurat timings that go beyond midnight are shown in the 24+ format.
All auspicious dates and timings to buy property are location-based, and it is important to set the city first before noting down Shubh dates and timings for property purchase and registration.
</p>


          </div>
        </section>
        <MuhuratLink />
      </div>
      <Footer />
       {/* Popup Modal */}
      {showPopup && (
        <div className="popup-overlay" onClick={() => setShowPopup(false)}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <h2>24+ Time Format Explanation</h2>
            <p>The time shown in Panchang as 27:44:45+ is not very different from standard HH:MM:SS time format followed universally. Sometimes seconds are removed when error of one minute is acceptable.

The + (plus sign) just after the Muhurta time indicates that the time is after the midnight i.e. on the next day on Gregorian or English Calendar. This is due to represent sunrise to sunrise day duration for the Hindu calendar. As per Hindu Calendar the current day doesn't get over at the midnight but it gets over at the sunrise on the next day. Even new weekday i.e. Monday, Tuesday, etc. starts after sunrise and due to this representation weekday from previous day continues till the sunrise.

All start and end timings which fall between midnight and next day sunrise are shown in 24+ hour format. It is done to maintain continuity of the day beyond midnight. To understand such timings, please subtract 24 from it. After subtraction one gets standard time for the next day on Gregorian calendar.

</p>
            <button className="popup-close" onClick={() => setShowPopup(false)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Property;
